// extracted by mini-css-extract-plugin
module.exports = {"img":"Img_img__3-ZJX","bordered":"Img_bordered__2Iqbk","fullwidth":"Img_fullwidth__2MmtF"};